import { signOut } from 'firebase/auth';
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import auth from '../../firebase.init';
import img from './car.png';

const Header = () => {

     const handleSignOut = () => {
          signOut(auth)
     }
     const [user] = useAuthState(auth);
     return (
          <div className="sticky-top ">
               <Navbar className=' fw-bolder' bg="white" expand="lg" >
                    <Container fluid >
                         <Navbar.Brand as={Link} to="/">
                              <img
                                   alt=""
                                   src={img}
                                   width="100"
                                   height="40"
                                   className="d-inline-block pb-2 align-top"
                              />{' '}
                              <span className='mt-4 text-primary'>Car-Web</span>
                         </Navbar.Brand>
                         <Navbar.Toggle aria-controls="navbarScroll" />
                         <Navbar.Collapse id="navbarScroll">
                              <Nav
                                   className="ms-auto  my-2 text-center my-lg-0"
                                   style={{ maxHeight: '100px' }}
                                   navbarScroll
                              >
                                   <Nav.Link as={Link} to="/about">Blogs</Nav.Link>
                                   {
                                        user && <>
                                             <Nav.Link as={Link} to="/addCar">AddCar</Nav.Link>
                                             <Nav.Link as={Link} to="/myCar">MyCar</Nav.Link>
                                             <Nav.Link as={Link} to="/manageCar">ManageCar</Nav.Link>

                                        </>
                                   }
                                   {
                                        user ? <button className='btn btn-link  fw-bolder text-decoration-none' onClick={handleSignOut} >LogOut</button>
                                             :
                                             <Nav.Link as={Link} to="/login">

                                                  Login
                                             </Nav.Link>
                                   }



                              </Nav>
                         </Navbar.Collapse>
                    </Container>
               </Navbar>
          </div>
     );
};

export default Header;